import { render, staticRenderFns } from "./IncomingTenderVersionSelector.vue?vue&type=template&id=54ddb8df&scoped=true&"
import script from "./IncomingTenderVersionSelector.vue?vue&type=script&lang=js&"
export * from "./IncomingTenderVersionSelector.vue?vue&type=script&lang=js&"
import style0 from "./IncomingTenderVersionSelector.vue?vue&type=style&index=0&id=54ddb8df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ddb8df",
  null
  
)

export default component.exports